import { element, string, arrayOf, shape } from 'prop-types';
import React from 'react';
import ActionIcon from 'components/ActionIcon';

function renderSocialLinks(links) {
  return links.map(({ label, href }) => (
    <li key={href}>
      <ActionIcon
        target={label !== 'email' ? '_blank' : undefined}
        url={href}
        type={label}
        variant="knockout"
      />
    </li>
  ));
}

function EmailSignupConfirmation(props) {
  const { confirmationMsgHtml, socialLinks } = props;

  return (
    <section className="EmailSignupConfirmation">
      <div className="EmailSignupConfirmation__content">
        {confirmationMsgHtml}
        <div className="EmailSignupConfirmation__social">
          <p className="EmailSignupConfirmation__social-cta">Follow Us</p>
          <ul className="EmailSignupConfirmation__social-icons">
            {renderSocialLinks(socialLinks)}
          </ul>
        </div>
      </div>
    </section>
  );
}

EmailSignupConfirmation.propTypes = {
  confirmationMsgHtml: element,
  socialLinks: arrayOf(
    shape({
      href: string,
      label: string
    })
  ).isRequired
};

EmailSignupConfirmation.defaultProps = {
  confirmationMsgHtml: (
    <div>
      <h4 className="EmailSignupConfirmation__headline">Thank You!</h4>
      <p className="EmailSignupConfirmation__body">
        We&apos;ll be joining your inbox soon
      </p>
    </div>
  )
};

export default EmailSignupConfirmation;
